<template>
  <div class="page-container">
    <!-- 搜索栏 -->
    <div>
      <div class="page-card__header">
        <span style="padding-right: 20px"> 同期活动</span>
        <el-button round size="small" @click="go_to_ActivityApply"
          >活动申请列表</el-button
        >
        <el-button round size="small" @click="go_to_addActivity"
          >发布活动</el-button
        >
      </div>
    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%; padding: 0 20px">
      <el-table-column prop="title" label="活动名称"> </el-table-column>
      <el-table-column prop="desc" label="描述"> </el-table-column>
      <el-table-column prop="host" label="主讲人" width="80"> </el-table-column>
      <el-table-column prop="start_time" label="活动开始时间">
      </el-table-column>
      <el-table-column prop="end_time" label="活动结束时间"> </el-table-column>

      <el-table-column prop="booking" label="预约数" width="80">
      </el-table-column>
      <el-table-column prop="praise" label="点赞数" width="80">
      </el-table-column>
      <el-table-column prop="type" label="活动方式"> </el-table-column>

      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="handleClick(scope.row)">详情</el-button>
          <el-button type="text" class="action-btn--danger" @click="deleteClick(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "reserveList",
  data() {
    return {
      tableData: [],
      //分页
      // 总条目数 total
      aSum: 0,
      // 当前页数 currenr_page
      currentPage: 1,
      // 总页数 num_pages
      pageCount: 1,
      // 每页显示条目数 pagesize
      pagesize: 10,
    };
  },
  mounted() {
    this.datalist();
  },

  methods: {
    /** 获取活动列表数据 */
    datalist() {
      let url = this.baseUrl + "/admin/activitys/?ordering=-create_time";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    /** 分页切换处理 */
    handleCurrentChange(val) {
      let url =
        this.baseUrl + "/admin/activitys/?ordering=-create_time&page=" + val;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    /** 删除活动信息 */
    deleteClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let id = row.id;
        let url = this.baseUrl + "/admin/activitys/" + id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.datalist();
        });
      });
    },

    /** 跳转到活动详情页 */
    handleClick(row) {
      this.$router.push({
        name: "admin_activityDatail",
        query: { id: row.id },
      });
    },

    /** 跳转到发布活动页面 */
    go_to_addActivity() {
      this.$router.push({ name: "admin_addActivity" });
    },

    /** 跳转到活动申请列表页面 */
    go_to_ActivityApply() {
      this.$router.push({ name: "admin_ActivityApply" });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/activityList.vue